import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import DefaultIcon from '@material-ui/icons/Search';
var styles = {
  link: {
    textDecoration: 'none',
    color: 'black',
    display: 'inline-block',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '100%',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  label: {
    cursor: 'pointer'
  }
};

var IconColumn = function IconColumn(props) {
  var children;
  var custom = props.custom;
  var data = {
    index: props.index,
    rowData: props.rowData
  };

  var iconClickHandler = function iconClickHandler() {
    if (props.onClick && typeof props.onClick === 'function') {
      props.onClick(data);
    }
  };

  if (props.renderIcons) {
    children = props.renderIcons(data);
  } else if (props.children) {
    children = props.children;
  } else {
    children = React.createElement(DefaultIcon, null);
  }

  var style = custom ? typeof custom.style === 'function' ? custom.style(props.rowData, props.colData) : custom.style : {};
  return React.createElement("div", {
    "data-testid": "iconcolumn-div",
    className: "".concat(props.classes.label, " ").concat(props.testClass || ''),
    onClick: function onClick() {
      return iconClickHandler();
    },
    style: style
  }, children);
};

export default withStyles(styles)(IconColumn);